import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";
import { PincodebreadcrumbsList } from "../Const";

const PincodeListForm = ({ edit = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}pincode/get/${id}`)
      .then((response) => {
        setValue("pincode", response.data.pincode);
        setValue("delivarable", response.data.delivarable);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(`pincode/update/${id}`, "PATCH", fields);
      if (result.data?.message === "Pincodes updated successfully") {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`pincode/create`, "POST", fields);
      if (result.data?.message === "Pincodes created successfully") {
        setSuccess(true);
      }
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="healthsyMasterBreadCrumbs"
                breadcrumbsList={PincodebreadcrumbsList("", edit)}
              />
              <BackBtn navigatePath="/healthsy-services/order-medicines/masters/pincode-list" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-6">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Pincode"
                  errorText="Please enter the Pincode"
                  name="pincode"
                  placeholder="Type here..."
                />
              </div>
              <div className="col-6">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  labelName="Delivary Status"
                  delivary_status={true}
                />
              </div>
            </div>
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </MainconternLayout>
      {success && (
        <SucessModal
          page={"/healthsy-services/order-medicines/masters/pincode-list"}
          name="new pincode"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default PincodeListForm;
